/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ValidateCouponResponseDuration = typeof ValidateCouponResponseDuration[keyof typeof ValidateCouponResponseDuration];


export const ValidateCouponResponseDuration = {
  once: 'once',
  repeating: 'repeating',
  forever: 'forever',
} as const;
